<template>
<div class="page">
  <div class="info-title">{{ info.studentNameTitle }}信息</div>
  <div class="info-main">
    <div class="info-base">姓名：{{ info.studentName }}</div>
    <div class="info-base">性别：{{ info.sex }}</div>
    <div class="info-box">
        <div class="info-name-title">{{ info.schoolNameTitle }}：</div>
        <div class="info-name-value">{{ info.schoolName }}</div>
      </div>
    <div class="info-box">
      <div class="info-name-title">{{ info.clazzNameTitle }}：</div>
      <div class="info-name-value">{{ info.clazzName }}</div>
    </div>
  
  </div>
  <div id="qrCode" class="ewmcode" ref="qrCodeDiv"></div>
  <div class="tip">扫码看检查结果</div>
</div>
</template>
<script>
import QRCode from 'qrcodejs2';

export default {
  name: 'QrcodePage',
  data() {
    return {
      uid: '',
      info: {},
    }
  },
  mounted() {
    this.uid = this.$route.query.uid;
    this.createQrcode();
  },
  methods: {
    async createQrcode() {
      const result = await this.$http.get(this.$url.getStudentInfobyuid, {
        uid: this.uid
      });
      this.info = result.data.info;
      const _this = this;
      new QRCode(_this.$refs.qrCodeDiv, {
        text: this.info.codeUrl,
        width: 150,
        height: 150,
        colorDark: '#333333', //二维码颜色
        colorLight: '#ffffff', //二维码背景色
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      });
    }
  }
}
</script>
<style scoped lang="less">
.page {
  margin: 0.3rem;
}
.info-title {
  font-size: 0.4rem;
  font-weight: bold;
}
.info-main {
  display: flex;
  flex-wrap: wrap;  
  width: 6.9rem;   
  margin-top: 0.3rem;
  .info-base {
    width: 50%;
    line-height: 1.6em;
    padding: 0.3rem 0;
    border-bottom: 1px solid #ccc;
    font-size: 0.32rem;
    text-align: left;
  }
  .info-box {
    display: flex;    
    flex-wrap: wrap;  
    border-bottom: 1px solid #ccc;
    width: 100%;
    div {
      line-height: 1.6em;
      padding: 0.3rem 0;
      word-wrap: break-word;
      font-size: 0.32rem;
      text-align: left;
      &.info-name-title{
        width: 3em;
      }
      &.info-name-value {
        width: 5.5rem;
      }
    }
  }
}
.ewmcode {
  width: 150px;
  height: 150px;
  margin: 1rem auto 0.2rem;
}
.tip {
  font-size: 0.28rem;
}
</style>